import $ from "jquery";
import { register } from "@shopify/theme-sections";

const selectors = {
	elements: {
		// collectionWrapper: "#algolia-product-grid",
		// sortByWrapper: ".algolia__sorting-wrapper",
		sortBySelect: ".ais-SortBy-select",
		sortByOptions: ".ais-SortBy-option",
		// categoryItems: ".algolia__category",
		paginationList: ".ais-Pagination",
		loadMoreWrapper: ".collection__load-more",
		itemsQuantity: "#items-qty",
		itemsOnCollection: ".ais-Hits-item"
	},
	action: {
		resetSort: "[data-sort-reset]",
		changeSort: '[name="sorting-radio"]',
		// categoryButtons: ".algolia__category-button",
		paginationButtons: ".ais-Pagination-link",
		loadMoreButton: "#collection_pagination"
	},
	modifier: {
		active: "active"
	}
};

register("collection", {
	onLoad: function () {
		$(document).on("click", selectors.action.changeSort, this.changeSort);
		$(document).on(
			"click",
			selectors.action.resetSort,
			this.resetSortFunction
		);
		$(document).on(
			"click",
			selectors.action.categoryButtons,
			this.openCategory
		);

		$(document).on(
			"click",
			selectors.action.paginationButtons,
			this.paginationScroll
		);

		$(document).on(
			"click",
			selectors.action.loadMoreButton,
			this.paginationLoadMore
		);

		this.renderColor();
		this.deletePreload();

		$(selectors.elements.sortBySelect).hide();
	},
	deletePreload: function () {},
	openCategory: function (event) {
		let $this = $(event.target),
			$thisCategoryButtonStatus = $this.attr("aria-expanded"),
			$categoryButtons = $(selectors.action.categoryButtons),
			$categoryItems = $(selectors.elements.categoryItems),
			$currentCategoryItem = $("#" + $this.attr("aria-controls")),
			$currentCategoryItemStatus =
				$currentCategoryItem.attr("aria-hidden");

		$categoryButtons.attr("aria-expanded", "false");
		if ($thisCategoryButtonStatus == "false") {
			$this.attr("aria-expanded", "true");
		}

		$categoryItems.attr("aria-hidden", "true");
		if ($currentCategoryItemStatus == "true") {
			$currentCategoryItem.attr("aria-hidden", "false");
		}
	},
	paginationShow: function () {
		setTimeout(function () {
			const loadMoreButton = document.querySelector(
					selectors.action.loadMoreButton
				),
				productCount = parseInt(
					loadMoreButton.getAttribute("data-count").replace(",", ""),
					10
				);

			if (loadMoreButton && productCount > 12) {
				document
					.querySelector(selectors.elements.loadMoreWrapper)
					.classList.add(selectors.modifier.active);
			}
		}, 100);
	},
	paginationLoadMore: function () {
		const itemQty = document.querySelector(
			selectors.elements.itemsQuantity
		);
		const itemQtyNumber = parseInt(itemQty.innerHTML, 10);
		const items = document.querySelectorAll(
			selectors.elements.itemsOnCollection
		);
		let counter = 0,
			itemCount = 0;
		for (let i = 0; i < items.length; i++) {
			let itemDisplay = window.getComputedStyle(items[i], null).display;
			if (itemDisplay != "block" && counter < 12) {
				counter++;
				items[i].style.display = "inline-block";
			}
			itemCount = i + 1;
			if (counter == 12) {
				break;
			}
		}
		itemQty.innerHTML = counter + itemQtyNumber;
		if (itemCount == items.length || counter == 0) {
			document
				.querySelector(selectors.action.loadMoreButton)
				.setAttribute("disabled", "disabled");
		}
	},
	paginationScroll: function () {
		let paginationPosition = document
			.querySelector(selectors.elements.paginationList)
			.getBoundingClientRect();
		window.scrollBy({
			top: paginationPosition.top - paginationPosition.height
		});
		window.scrollTo({ top: 1, behavior: "smooth" });
	},
	changeSort: function (event) {
		let $this = $(event.target),
			$sortParameters = $this.attr("id"),
			$sortStatus = $this.is(":checked");

		$(selectors.action.changeSort).prop("checked", false);

		if ($sortStatus) {
			$this.prop("checked", true);
			document.querySelector(
				'[value="' + $sortParameters + '"]'
			).selected = "selected";
			document
				.querySelector(selectors.elements.sortBySelect)
				.dispatchEvent(new Event("change"));
		} else {
			document.querySelectorAll(
				selectors.elements.sortByOptions
			)[0].selected = "selected";
			document
				.querySelector(selectors.elements.sortBySelect)
				.dispatchEvent(new Event("change"));
		}
	},
	resetSortFunction: function () {
		document.querySelectorAll(
			selectors.elements.sortByOptions
		)[0].selected = "selected";
		document
			.querySelector(selectors.elements.sortBySelect)
			.dispatchEvent(new Event("change"));
		document.querySelector(selectors.elements.sortByWrapper).innerHTML = "";
	},
	renderColor: function () {}
});
